import { defineMessages } from 'react-intl';

export default defineMessages({
  // TODO: make these common.title keys to share with shop cart / checkout
  itemDownloadableIndicator: {
    id: 'shop.cart.itemDownloadableIndicator',
    defaultMessage: 'Download',
  },
  itemProductHeader: {
    id: 'shop.cart.columnTitleProduct',
    defaultMessage: 'Product',
  },
  itemPriceHeader: {
    id: 'shop.cart.columnTitlePrice',
    defaultMessage: 'Price',
  },
  itemQuantityHeader: {
    id: 'shop.cart.columnTitleQuantity',
    defaultMessage: 'Qty',
  },
  itemTotalHeader: {
    id: 'shop.cart.columnTitleTotal',
    defaultMessage: 'Total',
  },
});
